/* eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

// Redux
import { useSelector, useDispatch } from 'react-redux';

// Material
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';

// Actions
import * as ReportActions from 'store/ducks/reports/actions';

// Types
import { ApplicationState } from 'store';

// Constants
import CONST_PAYMENT from 'constants/paymentsReceived';

// Styles
import useStyles from './receiveFilter.styles';

const ReceiveFilter: React.FC = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const filteredReceivePayments = useSelector(
    (state: ApplicationState) => state.reports.selectedReceivePayments,
  );

  const handleChangePayments = (payment: any) => {
    const updated = [...filteredReceivePayments];
    const index = filteredReceivePayments.findIndex(
      (e) => e.key === payment.KEY,
    );

    if (index === -1) {
      updated.push({ key: payment.KEY, value: payment.VALUE });
    } else updated.splice(index, 1);

    dispatch(
      ReportActions.setSelectedReceivePayments({
        selectedReceivePayments: updated,
      }),
    );
  };

  return (
    <List dense>
      {CONST_PAYMENT.TYPES.map((payment) => (
        <ListItem key={payment.KEY} button>
          <ListItemText
            id={payment.KEY}
            primary={payment.VALUE}
            onClick={() => handleChangePayments(payment)}
            classes={{ root: classes.itemText }}
          />
          <ListItemSecondaryAction>
            <Checkbox
              edge='end'
              color='primary'
              onChange={() => handleChangePayments(payment)}
              checked={
                !!filteredReceivePayments.find((e) => e.key === payment.KEY)
              }
              inputProps={{ 'aria-labelledby': payment.KEY }}
            />
          </ListItemSecondaryAction>
        </ListItem>
      ))}
    </List>
  );
};

export { ReceiveFilter };
export default ReceiveFilter;
